/*
 * Module pour la gestion de la modal modal-offrir-article qui permet d'offrir un article sur la page article   *
 */
(function ($, Global) {
    var FormOffrirArticle = function (model) {
        this.model = model;
    }

    FormOffrirArticle.prototype.initEvents = function () {
        this.publishers();
    }

    FormOffrirArticle.prototype.publishers = function () {
        var self = this;
        $(document).ready(function () {
           
            // Formulaire destinataire complété, on envoi l'info au site pour envoyer l'article offert au destinataire
            $(document).on('submit', '.form-offrirarticle-envoi', function (e) {
                    e.preventDefault();

                    var $this = $(this);
                    var data = $this.serializeJson();
                    var $form = $this.closest('form');
                    var $modalBody = $form.closest('.modal-body');


                    if ($modalBody.exists()) {
                        $.Topic('loader-show').publish($form.closest('.modal-content'));
                    }

                    $modalBody.children('.success').hide();
                    $modalBody.children('.warning').hide();

                    self.model.offer(data,$form,
                        function (data) {
                            if ($modalBody.exists()) {
                                $.Topic('loader-hide').publish($form.closest('.modal-content'));
                            }
                            if (data.isSuccess === false) {

                                return;
                            }

                            if (data.data) {
                                $modalBody.children('.form-offrirarticle-envoi').hide();                                
                                $modalBody.children('.success').show();
                                $modalBody.children('.success').html(data.feedback);
                            } else {
                                $modalBody.children('.warning').show();
                                $modalBody.children('.warning').html(data.feedback);                                
                                $modalBody.children('.warning').css("color", "white");
                            }


                        });
            });

            // On close la modal, on réinitialise le formulaire
            $(document).on('hidden.bs.modal', '.modal-offrir-article', function () {
                var $this = $(this);
                var $modalBody = $this.find('.modal-body');
                $modalBody.children('.success').hide();
                $modalBody.children('.warning').hide();
                $modalBody.children('.form-offrirarticle-envoi').show();
                $modalBody.find('[name="DestinataireNom"]').val('');
                $modalBody.find('[name="DestinataireEmail"]').val('');
                $modalBody.find('[name="MessagePourDestinataire"]').val('');    
            });

        });

    }

    Global.FormOffrirArticle = FormOffrirArticle;
}(jQuery, window));